module.exports = {"520103019":"大营路街道","520103020":"黔灵东路街道","520103021":"文昌阁街道","520103022":"盐务街街道","520103023":"普陀路街道","520103024":"八鸽岩街道","520103025":"毓秀路街道","520103026":"威清门街道","520103027":"市西河街道","520103028":"头桥街道","520103029":"三桥路街道","520103030":"马王街道","520103031":"金关街道","520103032":"茶园路街道","520103033":"杨惠街道","520103034":"渔安街道","520103035":"水东路街道","520103100":"黔灵镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520103.json
// module id = 2580
// module chunks = 0